import { NgTemplateOutlet, TitleCasePipe } from '@angular/common';
import { Component, computed, inject, input, model, Signal } from '@angular/core';
import { HlmAutocompleteImports, provideHlmAutocompleteConfig } from '@spartan-ng/helm/autocomplete';
import { HlmItemSeparator } from '@spartan-ng/helm/item';
import { HlmLabelImports } from '@spartan-ng/helm/label';

import { LivrableCaractérisé } from '../../../livrables-caractérisés/model/livrable-caracterisé.model';
import { LivrableCaractériséStore } from '../../../livrables-caractérisés/store/livrable-caracterisé.store';
import { Module } from '../../../référentiel-métier-parcours/models/module.model';
import {
  ExpansionPanel,
  ExpansionPanelMenuAction,
} from '../../../shared/components/expansion-panel/expansion-panel.component';
import { TrierParPipe } from '../../../shared/pipes/trier-par.pipe';
import { GlobalFormGroup } from '../séquence-form-form-groups.types';
import { SéquenceFormService } from '../séquence-form.service';
import { Référentiel } from '../../../administration/gestion-référentiels/models/référentiel.model';

@Component({
  selector: 'app-detail-livrables',
  imports: [
    ExpansionPanel,
    HlmAutocompleteImports,
    HlmLabelImports,
    TrierParPipe,
    HlmItemSeparator,
    TitleCasePipe,
    NgTemplateOutlet,
  ],
  templateUrl: './detail-livrables.component.html',
  providers: [
    provideHlmAutocompleteConfig({
      transformOptionToString: (option: LivrableCaractérisé) => `${option.nom}`,
      transformValueToSearch: (option: LivrableCaractérisé) => `${option.nom}`,
    }),
  ],
})
export class DetailLivrablesComponent {
  readonly #detailFormService = inject(SéquenceFormService);
  readonly #livrableCaracteriseStore = inject(LivrableCaractériséStore);

  readonly form = input.required<GlobalFormGroup>();
  readonly referentiel = input.required<Référentiel>();
  readonly module = input.required<Module>();

  public readonly searchLivrable = model('');

  readonly traductions = computed(() => this.referentiel().metadonnees.traductions);

  readonly filteredLivrables = computed(() =>
    this.#livrableCaracteriseStore
      .entities()
      .filter((x) => x.nom.toLowerCase().includes(this.searchLivrable().toLowerCase())),
  );

  readonly livrableActions: Signal<ExpansionPanelMenuAction<LivrableCaractérisé>[]> = computed(() => [
    {
      icon: 'lucideTrash',
      label: `Supprimer le ${this.referentiel().metadonnees.traductions.livrable} de la séquence`,
      action: (livrable) => this.#supprimerLivrable(livrable),
      class: 'invisible group-hover/item:visible',
    },
  ]);

  ajouterLivrable(livrable: LivrableCaractérisé) {
    this.searchLivrable.set('');
    const livrables = this.livrables.value;
    if (livrables.findIndex((x) => x.id === livrable.id) === -1) livrables.push(livrable);

    this.livrables.setValue(livrables);
  }

  #supprimerLivrable(livrable: LivrableCaractérisé | undefined): void {
    if (!livrable) return;

    const livrables = this.livrables.value;
    const index = livrables.findIndex((x) => x.id === livrable.id);

    if (index !== -1) livrables.splice(index, 1);

    this.livrables.setValue(livrables);
  }

  get livrables() {
    return this.#detailFormService.livrables;
  }
}
